import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-07/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "A directional loudspeaker with the sensitivity level of 93 dB/1W/1m and the on-axis<br>directivity index of 8 dB is placed into a shoe-box shaped room that is 20 meters<br>long, 14 meters wide, and 8 meters high. The measured reverberation time in the<br>room is 3 seconds. If the loudspeaker is fed with 10 W of electrical power, calculate:",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [3, 3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "html",
                  data: "The level of reverberant sound in the room.",
                },
              },
              styles: {
                alignItems: "flex-end",
                textAlign: "center",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/07/task/task-label.svg`,
                },
              },
              styles: {
                padding: "1%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default task;
